import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { AIChat } from './AIChat';
import { PlanSelector } from './PlanSelector';
export function HeroSection() {
  const [isPlanSelectorOpen, setIsPlanSelectorOpen] = useState(false);
  useEffect(() => {
    const handleOpenPlanSelector = () => {
      setIsPlanSelectorOpen(true);
    };
    window.addEventListener('openPlanSelector', handleOpenPlanSelector);
    return () => {
      window.removeEventListener('openPlanSelector', handleOpenPlanSelector);
    };
  }, []);
  return <section className="w-full bg-gradient-to-br from-[#F9FAFB] to-[#EFF6FF] pt-20" data-id="element-426">
      <div className="container mx-auto px-6 max-w-[1280px]" data-id="element-427">
        {/* Title and subtitle */}
        <div className="text-center mb-12" data-id="element-428">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4" data-id="element-429">
            Buy Your eSIM Instantly —{' '}
            <span className="text-[#2563EB]" data-id="element-430">Travel Connected.</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-431">
            Get instant mobile data in 190+ countries, skip SIM shops.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8" data-id="element-432">
            <Button variant="primary" size="lg" data-id="element-433">
              Get Your eSIM
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-434" />
            </Button>
            <Button variant="outline" size="lg" data-id="element-435">
              How It Works
            </Button>
          </div>
        </div>
        {/* Two column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start py-12" data-id="element-436">
          {/* Chat interface */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end" data-id="element-437">
            <AIChat data-id="element-438" />
          </div>
          {/* Phone mockup */}
          <div className="lg:col-span-7 flex justify-center lg:justify-start" data-id="element-439">
            <div className="relative max-w-[500px] w-full" data-id="element-440">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#2563EB] to-[#F97316] rounded-3xl blur-lg opacity-30 animate-pulse" data-id="element-441"></div>
              <div className="relative bg-white rounded-3xl shadow-xl p-2 border border-gray-100" data-id="element-442">
                <img src="https://images.unsplash.com/photo-1598327105666-5b89351aff97?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2335&q=80" alt="Smartphone showing eSIM activation" className="w-full h-auto rounded-2xl" data-id="element-443" />
                <div className="absolute -bottom-4 -right-4 bg-white rounded-full shadow-lg p-3" data-id="element-444">
                  <div className="bg-[#10B981] text-white rounded-full p-2 animate-pulse" data-id="element-445">
                    <CheckCircleIcon className="h-6 w-6" data-id="element-446" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PlanSelector isOpen={isPlanSelectorOpen} onClose={() => setIsPlanSelectorOpen(false)} data-id="element-447" />
    </section>;
}